module.exports = __webpack_public_path__ + "u7.no2.27c43dd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u7.no2.jpg
// module id = JHoe
// module chunks = 0